import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_PATH = '/photos';

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (!window.location.pathname.startsWith(BASE_PATH)) {
      return;
    }

    const pagePath =
      window.location.pathname + window.location.search;
   
    // GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageview',
      page_path: pagePath,
      site_section: 'photos',
    });

    // GA4
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: pagePath,
        page_location: window.location.href,
      });
    }
  }, [location.pathname, location.search]);

  return null;
};

export default RouteTracker;